module.exports = __webpack_public_path__ + "img/中文.6deee2e7.png";